"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubscriptionEvent = exports.isRequest = exports.decode = exports.encode = exports.watchPath = void 0;
const bignumber_1 = require("@ethersproject/bignumber");
const zod_1 = require("zod");
const watchPath = (onChange) => {
    let prevPath = window.location.pathname + window.location.search;
    const observer = new MutationObserver(() => {
        let newPath = window.location.pathname + window.location.search;
        if (newPath !== prevPath) {
            prevPath = newPath;
            onChange(newPath);
        }
    });
    observer.observe(document, { subtree: true, childList: true });
    return () => observer.disconnect();
};
exports.watchPath = watchPath;
const encode = (data) => data && JSON.stringify(data);
exports.encode = encode;
const decode = (data) => JSON.parse(data, (key, value) => {
    if (isEncodedBigNumber(value)) {
        return bignumber_1.BigNumber.from(value.hex);
    }
    return value;
});
exports.decode = decode;
function isEncodedBigNumber(value) {
    return (value === null || value === void 0 ? void 0 : value.type) === 'BigNumber' && isNonEmptyString(value.hex);
}
function isNonEmptyString(value) {
    return typeof value === 'string' && value !== '';
}
function isRequest(data) {
    const requestSchema = zod_1.z.object({
        id: zod_1.z.string(),
        type: zod_1.z.string(),
        data: zod_1.z.any(),
    });
    const { success } = requestSchema.safeParse(data);
    return success;
}
exports.isRequest = isRequest;
function isSubscriptionEvent(data) {
    const requestSchema = zod_1.z.object({
        type: zod_1.z.string(),
        data: zod_1.z.any(),
    });
    const { success } = requestSchema.safeParse(data);
    return success;
}
exports.isSubscriptionEvent = isSubscriptionEvent;
//# sourceMappingURL=util.js.map